/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Registration from '../views/Registration.vue'
import ChangePassword from '../views/ChangePassword.vue'
import Account from '../views/Account.vue'
import PageFrame from '../views/PageFrame.vue'
import PageDefault from '../views/PageDefault.vue'
import PageNoData from '../views/PageNoData.vue'
import SessionExpired from '../views/SessionExpired.vue'

export default [
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: { pub: true }
  },
  {
    path: '/logout',      
    name: 'logout',
    component: Logout,
    meta: { pub: true, track: { where: { section: "System", page: "Logout", view: "Logout" } } }
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    component: ChangePassword,
    props: true,
    meta: { pub: true }
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword,
    meta: { pub: true }
  },
  {
    path: '/registration',
    name: 'registration',
    component: Registration,
    meta: { pub: true }
  },
  {
    path: '/account',
    name: 'account',
    component: Account
  },
  {
    path: '/sessionExpired',      
    name: 'sessionExpired',
    component: SessionExpired,
    meta: { pub: true, track: { where: { section: "System", page: "SessionExpired", view: "SessionExpired" } } }
  },
  {
    path: '/page/:id',
    name: 'pageFrame',
    component: PageFrame,
    meta: { 
      bindModel: 'chat-analytics',
      filterAction: 'fetchChatFilters',
      filterNames: ['date'],
      headerMenuItems: [
        {name:'brands-widget'},
      ]
    },
    props: true
  },
  {
    path: '/default',
    name: 'default',
    component: PageDefault,
    props: true,
    meta: { track: { where: { section: "System", page: "Login", view: "Login" } } }
  },{
    path: '/reload',
    name: 'reload',
    component: PageDefault,
    props: true,
  },
  {
    path: '/nodata',
    name: 'nodata',
    component: PageNoData,
    meta: { 
      headerMenuItems: [
        {name:'brands-widget'},
      ]
    }
  },
]

